import { render, staticRenderFns } from "./ResearchersSearch.vue?vue&type=template&id=784c6bc4&scoped=true&"
import script from "./ResearchersSearch.vue?vue&type=script&lang=js&"
export * from "./ResearchersSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784c6bc4",
  null
  
)

export default component.exports